module.exports = __webpack_public_path__ + "img/thanks.982e1eac.png";